import { render, staticRenderFns } from "./ActiveClassPackage.vue?vue&type=template&id=79ec2eec&scoped=true&"
import script from "./ActiveClassPackage.vue?vue&type=script&lang=js&"
export * from "./ActiveClassPackage.vue?vue&type=script&lang=js&"
import style0 from "./ActiveClassPackage.vue?vue&type=style&index=0&id=79ec2eec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ec2eec",
  null
  
)

export default component.exports